import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'Fired when a user successfully creates a new skill',
  name: 'skill_created',
  params: [
    {
      description: 'ID of the created skill',
      name: 'skill_id',
      required: true,
      type: 'string',
    },
    {
      description: 'Whether the skill was published to workspace immediately',
      name: 'scope',
      required: true,
      type: 'enum',
      values: ['private', 'workspace'],
    },
  ],
};

export default META;
